import React, { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import axios from "../../../Axios";
import { Urls } from "../../../Urls";
import AllocationCard from "../components/AllocationCard";
import ProfileModal from "../../TransporterClientScreen/ProfileModal/ProfileModal";
import { currentRequestTimeStamp } from "../../../Constants";
import { useIndentTracking } from "../hooks/useIndentTracking";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";
import classes from "./ViewIndentSummary.module.css";

const statusLabel = (status) =>
  status === "rejected"
    ? "Rejected"
    : status === "accepted" || status === "allocated"
      ? "Accepted"
      : "Pending";

const statusClass = (status) =>
  status === "rejected"
    ? classes.statusRejected
    : status === "accepted" || status === "allocated"
      ? classes.statusAccepted
      : classes.statusPending;

const statusDotClass = (status) =>
  status === "rejected"
    ? classes.dotRejected
    : status === "accepted" || status === "allocated"
      ? classes.dotAccepted
      : classes.dotPending;

const ViewIndentSummary = ({
  item,
  isMobile,
  skipactive,
  autoView,
  emailTemplate,
}) => {
  const [sendinglist, setSendinglist] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const { trackIndentEvent } = useIndentTracking();
  const [updatedSummary, setUpdatedSummary] = useState(item.summary);
  const { userDetails } = useContext(UserApiContext)
  const showTabs =
    item?.pm_expired_indent_id &&
    item?.indent_type === "private_market_place_indent";
  const [view, setView] = useState("latest");

  useEffect(() => {
    trackIndentEvent(
      "indent request",
      "user has clicked allocation summary button",
      `Lane - ${item?.indent_info?.origin?.location?.label || "NA"} to ${item?.indent_info?.destination?.location?.label || "NA"
      }, Truck Type - ${Array.isArray(item?.indent_info?.truck_types)
        ? item.indent_info.truck_types.length > 0
          ? item.indent_info.truck_types
            .map((truck) => truck.label)
            .join(", ")
          : "NA"
        : item?.indent_info?.truck_types?.label || "NA"
      }`
    );
  }, [item]);

  useEffect(() => {
    // is trucks requested equals trucks allocated
    if (
      parseInt(item?.allocation_status?.total_trucks_requested) ===
      parseInt(item?.allocation_status?.allocated)
    ) {
      // copy of the summary to update the transporter statuses
      const updatedTransporters = item.summary.map((transporter) => {
        if (transporter?.allocation?.allocated_status !== "yes") {
          return {
            ...transporter,
            indent_status: "not allocated", // Change status to "not allocated"
          };
        }
        return transporter;
      });

      setUpdatedSummary(updatedTransporters);
    } else {
      setUpdatedSummary(item.summary);
    }
  }, [item]);

  const onInputChange = (e, transporter, transporter_name) => {
    setDisabled(false);
    const updatedList = [...sendinglist];
    const transporterIndex = updatedList.findIndex(
      (l) => l.transporter_id === transporter
    );

    if (transporterIndex !== -1) {
      updatedList[transporterIndex].allocated_truck =
        e !== "" ? parseInt(e) : 0;
    } else {
      updatedList.push({
        transporter_id: transporter,
        transporter_name,
        allocated_truck: e !== "" ? parseInt(e) : 0,
      });
    }

    setSendinglist(updatedList);
  };

  const clickHandler = (item) => {
    setDisabled(true);
    if (sendinglist.length > 0) {
      let totalAllocated = 0;
      let invalidAllocation = false;

      sendinglist.forEach((al) => {
        if (al.allocated_truck <= 0 || al.allocated_truck === null) {
          invalidAllocation = true;
        } else {
          totalAllocated += al.allocated_truck;
        }
      });

      if (invalidAllocation) {
        toast.info("Trucks allocated cannot be negative or zero");
        return;
      }

      if (totalAllocated <= item.indent_info.truck_required) {
        const payload = {
          allocation_info: sendinglist,
          total_allocation: totalAllocated,
          field: "update_allocation_status",
        };

        axios
          .put(
            `${Urls.indent}?indent_id=${item.indent_id}&field=allocation_truck`,
            payload
          )
          .then(() => {
            toast.success("Trucks Allocated Successfully");
            // Trigger follow-up actions (like applying filter)
            apply_Filter(
              true,
              skipactive,
              10,
              (skipactive - 1) * 10 + 10,
              0,
              "active"
            );
            sendEmails(item, totalAllocated);
          })
          .catch((e) => console.error("Error allocating trucks:", e));
      } else {
        toast.info(
          "The number of trucks allocated cannot exceed the number of trucks requested"
        );
      }
    }
  };

  const sendEmails = (item, totalAllocated) => {
    const companyMail = userDetails.email;
    const transporterName = sendinglist[0]?.transporter_name;
    const transporterEmail = sendinglist[0]?.transporter_name; // Example, might need adjustment

    const indentTable = `
      <table border="1">
        <thead>
          <th>Indent ID</th>
          <th>Transporter Name</th>
          <th>Origin</th>
          <th>Destination</th>
          <th>Truck Type</th>
          <th>#trucks confirmed for placement</th>
          <th>Date of Placement/Contract</th>
        </thead>
        <tbody>
          <tr>
            <td>${item.display_indent_id}</td>
            <td>${transporterName}</td>
            <td>${item.indent_info.origin.location_name}</td>
            <td>${item.indent_info.destination.location_name}</td>
            <td>${item.indent_info.truck_types[0].value}</td>
            <td>${totalAllocated}</td>
            <td>${item.indent_info.placement_date}</td>
          </tr>
        </tbody>
      </table>
    `;

    const emailBody = {
      activity: "Email Request",
      type: "superlaunch",
      mail_status: "Pending",
      from_email:
        emailTemplate.allocateFromCompany === "user"
          ? companyMail
          : "connect@logisticsnow.in",
      user_type: "company",
      cc: emailTemplate.allocateCCCompany || "connect@logisticsnow.in",
      subject: emailTemplate.allocateSubjectCompany,
      content: emailTemplate.allocateContentCompany,
      to_email: companyMail,
      Application_name: "lorri",
      module_name: "Indents",
      timestamp: currentRequestTimeStamp(),
    };

    mailerAPI(emailBody, setshow);

    // Sending to transporter (if needed)
    sendinglist.forEach((transporter) => {
      if (transporter.transporter_id) {
        const transporterEmailBody = {
          ...emailBody,
          to_email: transporterEmail,
          subject: emailTemplate.allocateSubjectTransporter,
          content: emailTemplate.allocateContentTransporter,
        };
        mailerAPI(transporterEmailBody, setshow);
      }
    });
  };

  const renderSummaryRow = (data, index) => (
    <div
      key={index}
      className={classes.row}
      style={{ animationDelay: `${Math.min(index, 8) * 30}ms` }}
    >
      {autoView ? (
        <AllocationCard item={item} data={data} />
      ) : (
        <>
          <span className={`${classes.dot} ${statusDotClass(data.indent_status)}`} />

          <div className={classes.transporterInfo}>
            <ProfileModal
              style={{ textAlign: "left" }}
              transporter_list={updatedSummary}
              transporter_id={data.transporter_id}
              transporter_name={data.transporter_name}
              screenName={"Indent Request"}
              moduleName={"LoRRI Indents"}
            />
            {data.rank && <span className={classes.rank}>({data.rank})</span>}
          </div>

          <div className={`${classes.status} ${statusClass(data.indent_status)}`}>
            {statusLabel(data.indent_status)}
          </div>

          {data.quotation && (
            <input
              type="number"
              className={classes.quotationInput}
              onChange={(e) =>
                onInputChange(
                  e.target.value,
                  data.transporter_id,
                  data.transporter_name
                )
              }
              value={data.quotation}
            />
          )}

          {data.indent_status === "allocated" && data.allocation ? (
            <div className={classes.allocatedTrucks}>
              {data.allocation.allocated_truck}
            </div>
          ) : (
            data.indent_status === "accepted" && (
              <input
                type="number"
                placeholder="0"
                className={classes.truckInput}
                onInput={(e) =>
                  onInputChange(
                    e.target.value,
                    data.transporter_id,
                    data.transporter_name
                  )
                }
              />
            )
          )}
        </>
      )}
    </div>
  );

  const renderSummaryCounts = () => {
    if (autoView || !updatedSummary?.length) return null;
    const accepted = updatedSummary.filter(
      (d) => d.indent_status === "accepted" || d.indent_status === "allocated"
    ).length;
    const rejected = updatedSummary.filter((d) => d.indent_status === "rejected").length;
    const pending = updatedSummary.length - accepted - rejected;

    return (
      <div className={classes.summaryStrip}>
        <div className={classes.summaryItem}>
          <span className={`${classes.dot} ${classes.dotAccepted}`} />
          Accepted <b>{accepted}</b>
        </div>
        <div className={classes.summaryItem}>
          <span className={`${classes.dot} ${classes.dotPending}`} />
          Pending <b>{pending}</b>
        </div>
        <div className={classes.summaryItem}>
          <span className={`${classes.dot} ${classes.dotRejected}`} />
          Rejected <b>{rejected}</b>
        </div>
      </div>
    );
  };

  const renderSummaryList = () => (
    <>
      {updatedSummary?.length > 0 ? (
        <div className={classes.wrapper}>
          {renderSummaryCounts()}
          {updatedSummary.map((data, index) => renderSummaryRow(data, index))}

          {!item.is_delete || !item.is_expired ? (
            <div className={classes.submitWrap}>
              <button
                className={classes.submitButton}
                disabled={disabled}
                onClick={() => clickHandler(item)}
              >
                Submit
              </button>
            </div>
          ) : (
            <div className={classes.cancelledNotice}>
              This Indent Request has been cancelled
            </div>
          )}
        </div>
      ) : (
        <div className={classes.emptyState}>Awaiting Responses</div>
      )}
    </>
  );

  if (!showTabs) {
    return <div>{renderSummaryList()}</div>;
  }

  return (
    <div>
      <div className={classes.tabs}>
        <button
          type="button"
          onClick={() => setView("latest")}
          className={`${classes.tabButton} ${view === "latest" ? classes.tabButtonActive : ""}`}
        >
          Latest Responses
        </button>

        <button
          type="button"
          onClick={() => setView("initial")}
          className={`${classes.tabButton} ${view === "initial" ? classes.tabButtonActive : ""}`}
        >
          Initial Responses
        </button>
      </div>

      {view === "latest" && renderSummaryList()}

      {view === "initial" && (
        <div>
          <p className={classes.initialNote}>
            (This indent was shared with these LSPs first, but it was rejected or left pending until expiry before being moved to the <b>Private Marketplace</b>)
          </p>

          {item?.initial_lsp_response?.length > 0 ? (
            <div className={classes.tableWrap}>
              <table className={classes.table}>
                <thead>
                  <tr>
                    <th style={{ width: "48px" }}>#</th>
                    <th>Transporter Name</th>
                    <th style={{ width: "140px" }}>Indent Status</th>
                  </tr>
                </thead>
                <tbody>
                  {item?.initial_lsp_response?.map((v, i) => (
                    <tr key={v?.transporter_id}>
                      <td>{i + 1}</td>
                      <td>{v?.transporter_name}</td>
                      <td>
                        {v?.indent_status === "rejected" ? (
                          <span className={classes.badgeRejected}>Rejected</span>
                        ) : v?.indent_status === "pending" ? (
                          <span className={classes.badgePending}>Pending</span>
                        ) : (
                          <span className={classes.badgeNeutral}>N/A</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className={classes.emptyState}>No responses available.</div>
          )}
        </div>
      )}
    </div>
  );
};

export default ViewIndentSummary;
